import { createSelector } from 'reselect';

import * as Service from 'types/service';
import { countBy, filter, flattenDeep, includes, map, pickBy } from 'es-toolkit/compat';
import { elmPartiesSelector } from './elmPartiesSelector';
import { partyToTableSelector } from './tableToPartySelector';
import PartyStates from 'constants/partyStateConstants';

function computeSeatedTables(
  partyIdToTableId?: { [partyId: string]: number[] },
  parties?: NumericDictionary<Service.PartyFromElm>
) {
  const seatedPartyIds = map(
    filter(parties, (party) => party.state === PartyStates.seated),
    'id'
  );
  const tablesWithSeatedParties = flattenDeep(
    Object.values(
      pickBy(partyIdToTableId, (value, partyId) => includes(seatedPartyIds, parseInt(partyId, 10)))
    )
  );
  return countBy(tablesWithSeatedParties);
}

export default createSelector(partyToTableSelector, elmPartiesSelector, computeSeatedTables);
